export default __webpack_public_path__ + "static/media/share_blue.a747bd77.svg";